import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getWaitingContracterReview, getWaitReviewToClose } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitReviewToClose({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [projectTypeSearch, setProjectTypeSearch] = useState()
  const [departmentSearch, setDepartmentSearch] = useState()
  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
      setProjectTypeSearch(settingSchema.projectTypeOption)
      setDepartmentSearch(settingSchema.departmentOption)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch,
    department,
    projectType
  ) => {
    setIsLoading(true)

    try {
      const response = await getWaitReviewToClose(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch,
        department,
        projectType
      )

      setSchema(response)

      setProjectTypeSearch(response.projectTypeOption)
      setDepartmentSearch(response.departmentOption)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            departmentSearch={departmentSearch}
            projectTypeSearch={projectTypeSearch}
            setting={config && true}
          >
            <hr />
          </ProjectDataTable>
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการรอตรวจสอบปิดโครงการ',
  projectCodeText: 'รหัสโครงการ',
  departmentOption: {
    name: 'department',
    label: 'สำนัก',
    value: null,
    options: [],
  },
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'แสดง',
  totalSize: 1,
  values: [
    {
      id: '',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXXXXXX',
        statusName: 'XXXXXX',
      },
      projectBudget: '9,999,999.99',
      projectType: { value: 'โครงการ', label: '1' },
    },
  ],
}
